import { render, staticRenderFns } from "./CompareRow.vue?vue&type=template&id=430b74e2"
import script from "./CompareRow.vue?vue&type=script&lang=ts"
export * from "./CompareRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('430b74e2')) {
      api.createRecord('430b74e2', component.options)
    } else {
      api.reload('430b74e2', component.options)
    }
    module.hot.accept("./CompareRow.vue?vue&type=template&id=430b74e2", function () {
      api.rerender('430b74e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/comparison/CompareRow.vue"
export default component.exports